import React, { useState, useEffect } from "react";
import SignatureProfilesDetailsView from "../../views/signature-profiles-details/signature-profiles-details.view";
import {
  SignatureProfileService,
  ApplicationIconsService,
  LocalStorageService,
} from "../../../services";
import { SimpleLoading } from "../../pures";

function SignatureProfilesDetailsContainer({ children, id }) {
  const url = process.env.REACT_APP_MIFIRMA_API;

  const [isLoading, setIsLoading] = useState(false);
  const [profile, setProfile] = useState({});
  const [icons, setIcons] = useState(null);
  const [userDocumentProfiles, setUserDocumentProfiles] = useState([]);

  const localStorageService = new LocalStorageService();
  let token = localStorageService.getLocalStorageItem("token").idToken;
  let signatureProfilesService = new SignatureProfileService(url);
  let applicationIconsService = new ApplicationIconsService(url);

  const icon = async () => {
    await applicationIconsService
      .getApplicationIcons(token, id)
      .then((res) => {
        setIcons(res.data);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const fetch = async () => {
    let documentProfilesUser;
    try {
      const signaturesProfile =
        await signatureProfilesService.getSignatureProfilesById(token, id);

      documentProfilesUser = await signatureProfilesService.getDocumentProfiles(
        token
      );

      if (!signaturesProfile.data || signaturesProfile.statusCode !== 200)
        throw new Error("Error");

      setProfile(signaturesProfile.data);

      if (!signaturesProfile.data.documentProfile) {
        documentProfilesUser.data.map((item) => {
          item.checked = false;
          return item;
        });
      } else {
        const documentUserIds = new Set([
          ...signaturesProfile.data.documentProfile.documentProfile.map(
            (item) => item.id
          ),
        ]);
        documentProfilesUser.data
          .map((item) => {
            item.checked = false;
            return item;
          })
          .map((item) => {
            if (documentUserIds.has(item.id)) item.checked = true;
            return item;
          });
      }
      setUserDocumentProfiles(documentProfilesUser.data);
    } catch (e) {
      documentProfilesUser.data.map((item) => {
        item.checked = false;
        return item;
      });
      setUserDocumentProfiles(documentProfilesUser.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    fetch();
    icon();
  }, []);

  return children({
    isLoading,
    signatureProfilesService,
    applicationIconsService,
    token,
    profile,
    icons,
    userDocumentProfiles,
  });
}

export default function SignatureProfilesDetailsAction({ location }) {
  let { pathname } = location;
  let id = pathname.replace("/signature-profile-details", "").replace("/", "");

  return (
    <SignatureProfilesDetailsContainer id={id}>
      {({
        signatureProfilesService,
        applicationIconsService,
        token,
        profile,
        icons,
        isLoading,
        userDocumentProfiles,
      }) =>
        isLoading ? (
          <div>
            <SimpleLoading />
          </div>
        ) : (
          <SignatureProfilesDetailsView
            token={token}
            id={id}
            signatureProfilesService={signatureProfilesService}
            applicationIconsService={applicationIconsService}
            profile={profile}
            icons={icons}
            userDocumentProfiles={userDocumentProfiles}
          />
        )
      }
    </SignatureProfilesDetailsContainer>
  );
}
